import {Component, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {BaseComponent} from "@wms/components";
import {PrefabPublishService} from "@wms/prefab-publish";
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'wms-ptt-documentation',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './documentation.component.html',
  styleUrls: ['./documentation.component.less']
})
export class DocumentationComponent extends BaseComponent implements OnInit {
  @Input() documentationUrl: any;
  fetchingDoc: boolean;
  constructor(private prefabPublishService: PrefabPublishService, private httpClient: HttpClient) {
    super();
  }

  ngOnInit() {
    this.showDocumentation();
  }

  showDocumentation() {
    this.fetchingDoc = true;
    this.documentationUrl = this.prefabPublishService.ARTIFACTS_PUBLISH_DOC_API_URL.replace(/\:projectID/ig, this.projectService.getProjectId());
    //to avoid caching. adding random url param
    let url = this.documentationUrl + "?d=" + new Date().getTime();
    this.httpClient.get(url, {responseType: 'text'}).toPromise().then((response) => {
      this.fetchingDoc = false;
      this.documentationUrl = response;
    });
  }

}
